<div class="headerMainDiv">
    <div class="airaHeaderLogo">
        <img src="assets/images/common/am_logo.png" alt="Aira Logo" aria-label="Aira Logo" class="airaLogo" />
        <img src="assets/images/common/AIRAQC.png" alt="Aira Logo" aria-label="Aira Logo" class="airaLogoText" />
    </div>
    <div class="rightSideHeader">
        <div class="zoomWarningDiv paddingRight" *ngIf="isBroswerZoomed || systemZoomed">

        </div>

        <div class="selectRole">
            <mat-form-field appearance="fill" disableRipple
                [ngClass]="(userRoleArr.length === 1) ? 'singleRoleDropdown' : 'multiRoleDropdown'">
                <mat-select [(ngModel)]="selectedUserRole " (selectionChange)="changeRole()">
                    <mat-option class="headerOptions" *ngFor="let indvUserRole of userRoleArr"
                        [value]="indvUserRole.role">
                        {{indvUserRole.roleDisplayText | titlecase}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="circle" [ngStyle]="{'background-color': circleColor}">
            <div class="initials">{{initials}}</div>
        </div>
        <div class="usernm_header"> Hello {{firstName}} {{lastName}} </div>
        <img src='assets/images/svg/logoutIcon.svg' class="logouticon" [matMenuTriggerFor]="beforeMenu"
            (menuOpened)="showDashboardSave()" />
        <mat-menu #beforeMenu="matMenu" xPosition="before" class="headerMenuCard">
            <button mat-menu-item *ngIf="appConfig.licenseConfig?.enabled" (click)="renewLicense()">Renew License</button>
            <button mat-menu-item *ngIf="appConfig.showChangePassword" (click)="showChangePasswordDialog()">Change
                Password</button>
            <button mat-menu-item (click)="logout()">Logout</button>
        </mat-menu>
    </div>
</div>